function AppRouting($locationProvider) {
    $locationProvider.html5Mode(false);
    $locationProvider.hashPrefix('');
}

export default AppRouting;
